module.exports = __webpack_public_path__ + "img/mobile-three-women.fc870e61.png";